// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"1346":"ebecd360","2960":"e48519b3","5443":"ad7f724d"}[chunkId] || chunkId) + "." + {"1335":"13f3de5d7e5e9207","1346":"5382cfdaaeccfaa7","1662":"4178e14a3a9f89b5","2960":"c052f2030470388f","3601":"378f139fc89e0b22","5443":"1ac92d6c688d9c38","6543":"e90d26c29b22c6a1"}[chunkId] + ".js";
};